// Util de cores dinâmicas do web checkin.
// Fonte da verdade é o banco (config_boas_vindas). NÃO cacheamos cor no cliente:
// no boot, o App.vue rebusca do backend (via token de sessão) e reaplica as
// CSS vars em qualquer rota — por isso as cores sobrevivem ao reload.

const CORES_PADRAO = {
  corPrimaria: '#156CF7',
  corSecundaria: '#3f4849',
  corBotoes: '#156CF7',
};

// Mapeia a config do backend (cor_primaria, ...) para o formato usado no app.
export function extrairCores(config = {}) {
  return {
    corPrimaria: config.cor_primaria || CORES_PADRAO.corPrimaria,
    corSecundaria: config.cor_secundaria || CORES_PADRAO.corSecundaria,
    corBotoes: config.cor_botoes || CORES_PADRAO.corBotoes,
  };
}

// Aplica as cores como CSS variables no elemento raiz do documento.
export function aplicarCoresNoDOM(cores = {}) {
  const root = document.documentElement;
  root.style.setProperty('--wc-cor-primaria', cores.corPrimaria || CORES_PADRAO.corPrimaria);
  root.style.setProperty('--wc-cor-secundaria', cores.corSecundaria || CORES_PADRAO.corSecundaria);
  root.style.setProperty('--wc-cor-botoes', cores.corBotoes || CORES_PADRAO.corBotoes);
}

export { CORES_PADRAO };
